module.exports = __webpack_public_path__ + "assets/img/mecha-btn-ee5dae83.png";